import { render, staticRenderFns } from "./export-product-price.vue?vue&type=template&id=d1965f6e&"
import script from "./export-product-price.vue?vue&type=script&lang=js&"
export * from "./export-product-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports